import logger from '@/utils/logger';
/**
 * SÉCURITÉ: LOGS SÉLECTIFS EN PRODUCTION
 *
 * EN PRODUCTION: Logs critiques ACTIVÉS (debug, streaming upload)
 * EN DEV: Tous les logs activés
 */

const isProduction = import.meta.env.PROD;

// Whitelist de logs autorisés en production (pour debug)
const PROD_WHITELIST = [
  '[StreamingUpload]',
  '[BigData]',
  '[Backend]',
  '[ERROR]',
  '[WARN]'
];

const shouldLogInProd = (args: any[]): boolean => {
  if (!isProduction) return true;
  const firstArg = String(args[0] || '');
  return PROD_WHITELIST.some(prefix => firstArg.includes(prefix));
};

// SÉCURITÉ: En production = logs whitelist uniquement
const logger = {
  log: (...args: any[]) => {
    if (shouldLogInProd(args)) console.log('[LOG]', ...args);
  },

  info: (...args: any[]) => {
    if (shouldLogInProd(args)) console.info('[INFO]', ...args);
  },

  error: (...args: any[]) => {
    if (shouldLogInProd(args)) console.error('[ERROR]', ...args);
  },

  warn: (...args: any[]) => {
    if (shouldLogInProd(args)) console.warn('[WARN]', ...args);
  },

  debug: (...args: any[]) => {
    if (shouldLogInProd(args)) console.debug('[DEBUG]', ...args);
  },

  // Log conditionnel (pour tests)
  isDev: () => !isProduction,
  isProd: () => isProduction
};

// Export par défaut et nommé pour compatibilité maximale
export default logger;
export { logger };



